module.exports = __webpack_public_path__ + "e.no1.74496fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e.no1.jpg
// module id = 25Cx
// module chunks = 0